import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export interface UpdateRoleInput { id: string; name: string; description?: string | null; }
export function createUpdateRoleUseCase({ membershipRepository }: Deps) {
  return async function updateRole(input: UpdateRoleInput): Promise<void> {
    return membershipRepository.updateRole(input);
  };
}
